import type { ChargingStation } from '../../types';

const isSuperChargingStation = (station: ChargingStation) => {
  return Number(station.evDcFastNum) > 0;
};

export default isSuperChargingStation;
